<template>
    <div class="parking-amap">
        <!-- 搜索 -->
        <div class="parking-amap-search flex align-center">
            <div class="parking-amap-search-s" @click="toSearch">
                <img src="@/assets/images/parking/parking-search.png" alt="" />
                <span>搜索</span>
            </div>

            <div @click="toParkList" class="parking-amap-list-wrap">
                <img src="@/assets/images/parking/parking-list.png" alt="" />
            </div>
        </div>
        <!-- 地图 -->
        <div id="parkingContainer" class="amap" ref="map-parkingContainer"></div>

        <!-- 右侧控制条 -->
        <div class="parking-control-right">
            <div class="parking-control-item" v-for="(item, index) in parkingTypeList" :key="index"
                @click="changeType(item, index)">
                <img :src="activeControl == index ? item.iconA : item.iconD" alt="" />
            </div>
        </div>

        <!-- 底部左侧当前位置 -->
        <div class="position_icon" @click="setPosition"></div>
        <!-- 底部右侧放大缩小 -->
        <div class="scale_content">
            <div class="scale_item" @click="addZoom">+</div>
            <div class="divider"></div>
            <div class="scale_item" @click="cutZoom">-</div>
        </div>

        <!-- 底部左侧当前位置 -->
        <div class="scale_content">
            <div class="scale_item" @click="addZoom">+</div>
            <div class="divider"></div>
            <div class="scale_item" @click="cutZoom">-</div>
        </div>
        <!-- 底部车场弹出 -->
        <van-action-sheet v-model="showParkingLot" :overlay="false">
            <div class="parkingLot-content flex-column align-center">
                <div class="parkingLot-content-hide" @click="showParkingLot = false"></div>
                <div class="parkingLot-content-statistics flex align-center">
                    <img src="@/assets/images/parking/map.png" alt="" />
                    <div class="parkingLot-content-statistics-road" v-if="activeControl != 1">
                        <span>附近道路</span>
                        <span class="parkingLot-content-statistics-num">{{ roadNum }}</span>
                        <span>条</span>
                    </div>
                    <span class="parkingLot-content-statistics-divider"
                        v-if="activeControl == 0 || activeControl == 3">|</span>
                    <div class="parkingLot-content-statistics-parking" v-if="activeControl != 2">
                        <span>停车场</span>
                        <span class="parkingLot-content-statistics-num">{{ parkNum }}</span>
                        <span>个</span>
                    </div>
                </div>
                <div class="parkingLot-content-list">
                    <div @click="showNavigation(item)"
                        :class="['parkingLot-content-item', 'flex', 'align-center', item.type == 1 ? 'parkingLot-content-item-road' : 'parkingLot-content-item-park']"
                        v-for="(item, index) in parkingList" :key="index">
                        <p class="parkingLot-content-item-type">{{ item.type == 1 ? "道路" : "停车场" }}</p>
                        <div class="parkings-result-item flex">
                            <div class="result-item-left flex-column justify-between">
                                <div class="result-item-name">{{ item.parkName }}</div>
                                <div class="result-item-number">
                                    车位数量：<span
                                        :class="['result-item-number-surplus', item.restStall == 0 ? 'result-item-number0' : item.restStall >= 20 && item.restStall < 40 ? 'result-item-number20' : 'result-item-number40']">{{
                                                item.restStall
                                        }}</span><span class="result-item-number-total">/{{
        item.totalStall
}}</span>
                                </div>
                            </div>
                            <div class="result-item-right flex-column justify-center align-center">
                                <img src="@/assets/images/parking/sitelogo.png" alt="" />
                                <p>{{ item.distance }}km</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-action-sheet>
        <!-- 车场导航弹出 -->
        <van-action-sheet v-model="showParkingLotDetail" @click-overlay="hideDetail">
            <div class="parkingLot-detail flex-column align-center">
                <div class="parkingLot-detail-hide" @click="hideDetail"></div>
                <div class="parkingLot-detail-content">
                    <div class="parkingLot-detail-name">
                        <img src="@/assets/images/parking/parking.png" alt="" />
                        {{ detailData.parkName }}
                    </div>
                    <div class="parkingLot-detail-number-wrap flex algin-center justify-between">
                        <p class="result-item-number">
                            空车位：<span
                                :class="['result-item-number-surplus', detailData.restStall == 0 ? 'result-item-number0' : detailData.restStall >= 20 && detailData.restStall < 40 ? 'result-item-number20' : 'result-item-number40']">{{
                                        detailData.restStall
                                }}</span><span class="result-item-number-total">/{{
        detailData.totalStall
}}</span>
                        </p>
                        <p>距您 {{ detailData.distance }}km</p>
                    </div>
                    <div class="parkingLot-detail-rule flex align-center" @click="showRule">
                        <div class="parkingLot-detail-rule-left flex align-center">
                            <img src="@/assets/images/parking/parking-toll.png" alt="" />
                            <p>查看收费规则</p>
                        </div>
                        <div class="parkingLot-detail-rule-right">
                            <img src="@/assets/images/parking/parking-right.png" alt="" />
                        </div>
                    </div>
                    <van-button class="comfirm-btn" block @click="openMap">一键导航</van-button>
                </div>
            </div>
        </van-action-sheet>
        <!-- 收费规则弹出 -->
        <div class="toll-rule-dialog">
            <van-dialog v-model="showTollRule" :showConfirmButton="false">
                <div class="toll-rule-wrap">
                    <div class="toll-rule-wrap-header flex justify-between">
                        <p>收费规则</p>
                        <img src="@/assets/images/parking/parking-close.png" alt="" @click="showTollRule = false" />
                    </div>
                    <div class="toll-rule-item">
                        <div class="toll-rule-item-content">{{ detailData.instruction }}</div>
                    </div>

                    <!-- <div class="toll-rule-item">
                        <div class="toll-rule-item-title">[ 白天时段(7:30-22:00) ]</div>
                        <div class="toll-rule-item-content">半小时内免费，1小时内收费3元/辆、次，超过1小时后每增加30分钟收费2元/辆、次,不足30分钟按30分钟计,24小时最高封顶收费30元</div>
                    </div>
                    <div class="toll-rule-item">
                        <div class="toll-rule-item-title">[ 夜间时段(22:00-次日7::30) ]</div>
                        <div class="toll-rule-item-content">夜间免费</div>
                    </div> -->
                </div>
            </van-dialog>
        </div>

        <loading :show="loading" text="地图加载中" />
    </div>
</template>

<script>
import { bd_decrypt, obj2Param } from "@/libs/tools";
import { getParkDistribute } from "@/api/api";

// import AMapLoader from "@amap/amap-jsapi-loader";
import config from "@/config/index";
import Loading from "@/components/base/loading/loading.vue";
export default {
    name: "ParkingAmap",
    components: {
        Loading,
    },
    data() {
        return {
            map: null, // 地图实例
            timer: null,
            mapSize: 15,
            radius: 3, // 半径范围
            activeControl: 0, // 导航栏控制参数
            parkingTypeList: [
                {
                    name: "附近",
                    iconD: require("@/assets/images/parking/nearby-d.png"),
                    iconA: require("@/assets/images/parking/nearby-a.png"),
                },
                {
                    name: "停车场",
                    iconD: require("@/assets/images/parking/parking-d.png"),
                    iconA: require("@/assets/images/parking/parking-a.png"),
                },
                {
                    name: "道路",
                    iconD: require("@/assets/images/parking/road-d.png"),
                    iconA: require("@/assets/images/parking/road-a.png"),
                },
                {
                    name: "全部",
                    iconD: require("@/assets/images/parking/all-d.png"),
                    iconA: require("@/assets/images/parking/all-a.png"),
                },
            ],
            showParkingLot: false, // 底部车场控制参数
            parkingLotList: [], // 附近车场列表
            parkingList: [], // 切换产生的车场数据
            roadNum: 0, // 路内停车场数量
            parkNum: 0, // 路外停车场数量
            showParkingLotDetail: false, // 车场导航控制参数
            detailData: {}, // 车场选中 导航参数
            showTollRule: false, // 收费规则控制参数
            userLocation: {
                lng: 118.915804,
                lat: 25.120399,
                radius: 3,
            }, // 默认用户所在位置
            loading: true,
        };
    },
    mounted() {
        this.initMap();
    },

    methods: {
        // 初始化地图
        // initMap() {
        //     let that = this;
        //     if (this.$Amap) {
        //         console.log(this.$AMap);

        //         this.map = new this.$Amap.Map("parkingContainer", {
        //             zoom: that.mapSize, //级别
        //             resizeEnable: true,
        //             center: new AMap.LngLat(this.userLocation.lng + "", this.userLocation.lat + ""),
        //         });

        //         this.setPosition();
        //         clearInterval(this.timer);
        //     } else {
        //         this.timer = setInterval(this.initMap, 1000);
        //     }
        // },

        initMap() {
            let that = this;
            // AMapLoader.load({
            //     key: config.AMAP_KEY, // key
            //     plugins: ["AMap.Geocoder", "AMap.Geolocation", "AMap.AutoComplete"], // 插件
            // })
            //     .then((Amap, b) => {
            //         this.$Amap = Amap;
            //         that.map = new Amap.Map("parkingContainer", {
            //             zoom: that.mapSize, // 级别
            //             resizeEnable: true,
            //             center: new AMap.LngLat(this.userLocation.lng + "", this.userLocation.lat + ""),
            //         });
            //         that.map.on('complete', function () {
            //             // 地图图块加载完成后触发
            //             that.setPosition();
            //         });
            //     })
            //     .catch((err) => {
            //         throw new Error("加载高德地图失败：" + err);
            //     });
        },
        // 放大地图
        addZoom() {
            this.map.zoomIn();
        },
        // 缩小地图
        cutZoom() {
            this.map.zoomOut();
        },
        // 车场类型切换
        changeType(item, index) {
            if (this.parkingLotList.length == 0) return;
            this.showParkingLot = true;
            this.activeControl = index;

            this.parkingList = this.parkingLotList.filter((item) => {
                if (this.activeControl == 0 || this.activeControl == 3) return item;
                else if (this.activeControl == 1) return item.type == 2;
                else if (this.activeControl == 2) return item.type == 1;
            });
        },
        // 显示导航
        showNavigation(item) {
            this.showParkingLot = false;
            // vant组件不能马上更新 需要将下面的设置成异步的
            setTimeout(() => {
                this.showParkingLotDetail = true;
                this.detailData = item;
            }, 0);
        },
        // 隐藏车场详情
        hideDetail() {
            this.showParkingLotDetail = false;
            this.showParkingLot = true;
        },
        // 查看收费规则
        showRule() {
            this.showTollRule = true;
        },
        // 一键导航
        openMap() {
            let that = this;
            let locaton = bd_decrypt(that.detailData.lng, that.detailData.lat);

            let obj = {
                longitude: locaton.lng,
                latitude: locaton.lat,
                name: that.detailData.parkName, // 位置名
                address: that.detailData.address, // 地址详情说明
            };
            let str = obj2Param(obj);
            wx.miniProgram.navigateTo({
                url: `/pages/location/location?${str}`,
            });
        },
        // 获取当前定位
        setPosition() {
            let that = this;
            this.map.clearMap();
            let options = {
                showButton: false, // 是否显示定位按钮
                // 'buttonPosition': 'LB',//定位按钮的位置
                /* LT LB RT RB */
                // 'buttonOffset': new AMap.Pixel(10, 20),//定位按钮距离对应角落的距离
                showMarker: true, // 是否显示定位点
                showCircle: false, // 是否显示定位精度圈
                // noGeoLocation: 1, //手机禁止使用PI定位
            };

            this.map.plugin(["AMap.Geolocation"], function () {
                let geolocation = new that.$Amap.Geolocation(options);
                that.map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    that.loading = false;
                    if (status == "complete") {
                        console.log(result);
                        let address = result;
                        let obj = that.$route.params;
                        // // //如果传入地点 就用地点为中心
                        if (Object.keys(obj).length > 0 && obj.type == "address") {
                            address.position.lng = obj.lng;
                            address.position.lat = obj.lat;
                        }
                        console.log(address);
                        that.$store.commit("setLocation", address.position); // 将当前location存起来
                        that.userLocation.lng = address.position.lng;
                        that.userLocation.lat = address.position.lat;
                        that.setPositionWithPoint(address.position);
                    } else {
                        let address = {
                            position: {
                                lng: 118.915804,
                                lat: 25.120399,
                            },
                        };
                        that.setPositionWithPoint(address.position);
                        that.$toast("定位获取失败");
                    }
                });
            });
        },
        // 添加半径范围、当前位置
        setPositionWithPoint(p) {
            // 获取停车场数据
            let that = this;
            // 当前位置
            let myPosition = new AMap.Marker({
                map: that.map,
                offset: new AMap.Pixel(-7, -28),
                content: '<div class="location-point"></div>',
                position: new AMap.LngLat(p.lng + "", p.lat + ""),
            });
            // 半径圆
            let circle = new AMap.Circle({
                map: that.map,
                radius: that.userLocation.radius * 1000,
                strokeColor: "#0093FF",
                noSelect: true,
                strokeOpacity: 0.5,
                strokeWeight: 1,
                fillColor: "#02B0FF",
                fillOpacity: 0.25,
                center: new AMap.LngLat(p.lng + "", p.lat + ""),
            });

            this.getParking(p);

            setTimeout(() => {
                this.map.setZoomAndCenter(this.mapSize, [p.lng, p.lat]);
            }, 1);
        },
        // 根据用户所在经纬度获取停车场
        getParking(point) {
            let that = this;
            let obj = {
                lat: point.lat,
                lng: point.lng,
                radius: this.userLocation.radius,
            };
            getParkDistribute(obj).then((res) => {
                if (res.code == 200) {
                    that.parkingLotList = res.data.rows;
                    that.parkingList = res.data.rows;
                    let points = res.data.rows;

                    if (points.length > 0) {
                        // 判断当前是有选择某个车场
                        let obj = that.$route.params;
                        if (Object.keys(obj).length > 0 && obj.type == "parking") {
                            that.showParkingLotDetail = true;
                            that.detailData = obj;
                        }
                        that.showParkingLot = true; // 弹出底部车场
                        that.addPointToMap(points);
                    }
                }
            });
        },
        // 点聚合
        setMarkerClusterer(map, markers) {
            let that = this;
            let count = markers.length;

            const _renderClusterMarker = function (context) {
                let markers = context.markers;
                var stallCodeNum = 0;
                let stallCodeAreaData = [];
                for (let i = 0; i < markers.length; i++) {
                    for (let j = 0; j < that.parkingLotList.length; j++) {
                        if (markers[i].ids == that.parkingLotList[j].ids) {
                            stallCodeAreaData.push(that.parkingLotList[j]);
                            stallCodeNum += that.parkingLotList[j].restStall * 1;
                        }
                    }
                }
                for (let i = 0; i < stallCodeAreaData.length; i++) {
                    if (i > 0) {
                        if (stallCodeAreaData[i].lat == stallCodeAreaData[i - 1].lat && stallCodeAreaData[i].lng == stallCodeAreaData[i - 1].lng) {
                        }
                    }
                }

                context.marker.setOffset(new AMap.Pixel(-32.5, -74.5));

                context.marker.setContent(`
                     <div class="amap-marker-content-road">
                        <p class="parkinglot-name-road">停车场</p>
                         <p class="parkinglot-num-road">${stallCodeNum}</p>
                     </div>
                    `);
            };

            AMap.plugin(["AMap.MarkerClusterer"], function () {
                let cluster = new AMap.MarkerClusterer(map, markers, {
                    // styles: sts,
                    gridSize: 80,
                    renderClusterMarker: _renderClusterMarker,
                });
            });
        },
        // 添加地图点到地图中
        addPointToMap(points) {
            let that = this;
            let roadNum = 0;
            let parkNum = 0;
            let markers = [];
            for (let i = 0; i < points.length; i++) {
                // 区分开路内停车和路外停车
                if (points[i].type == 1) roadNum++;
                else if (points[i].type == 2) parkNum++;

                let rate = (points[i].restStall || 0) / (points[i].totalStall && points[i].totalStall > 0 ? points[i].totalStall : 1);
                let type = "red";
                if (rate > 0.6) {
                    type = "green";
                } else if (rate > 0.3) {
                    type = "orange";
                }

                let gd_point = bd_decrypt(points[i].lng, points[i].lat);

                let marker = new AMap.Marker({
                    position: [gd_point.lng, gd_point.lat],
                    // content: `<div style="border:1px red solid;width: 80px;height: 43.5px;"></div>`,

                    content: `<div style=""  class="amap-marker-content-${type}">
                        <p class="parkinglot-name-${type}">${points[i].parkName}</p>
                        <p class="parkinglot-num-${type}">${points[i].restStall}</p>
                    </div>`,

                    title: points[i].name,
                    clickable: true,
                    // anchor: "center",
                    offset: new AMap.Pixel(-40, -43.5),
                });

                marker.on("click", function (e) {
                    that.showNavigation(points[i]);
                });
                this.map.add(marker);
                marker["ids"] = i;
                that.parkingLotList[i]["ids"] = i;

                markers.push(marker);
            }
            this.setMarkerClusterer(this.map, markers);
            this.roadNum = roadNum;
            this.parkNum = parkNum;
        },
        // 跳转到停车场列表页面
        toParkList() {
            this.$router.push({ name: "ParkingsSearch", params: this.userLocation });
        },
        // 跳转到搜索停车场列表页面
        toSearch() {
            this.$router.push({ name: "SearchParkinglot", params: this.userLocation });
        },
    },

    beforeDestroy() {
        this.map.destroy();
    },

    activated() {
        console.log("我被缓存了");
    },
    deactivated() {
        console.log("我退出了");
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.marker_content {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 59px;
    width: 110px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
}

.marker_content span:first-child {
    font-size: 14px;
    margin-top: 6px;
}

.marker_content span:last-child {
    font-size: 12px;
}

.parking-amap {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .parking-amap-search {
        width: 686px;
        height: 66px;
        border-radius: 16px;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        z-index: 8;
        position: fixed;
        top: 12px;
        left: 32px;
        padding: 0 24px;

        .parking-amap-search-s {
            width: 580px;
        }

        img {
            width: 24px;
            height: 24px;
        }

        span {
            font-size: 24px;
            color: #999999;
            margin-left: 13px;
        }

        .parking-amap-list-wrap {
            margin-left: auto;
            position: relative;
            height: 24px;

            &::before {
                position: absolute;
                content: "";
                left: -24px;
                top: -8px;
                height: 40px;
                width: 1px;
                background-color: #e8e8e8;
            }
        }
    }

    .amap {
        width: 100%;
        height: 100%;
    }

    .amap-marker-content {
        color: #fff;
    }

    .parking-control-right {
        position: fixed;
        right: 32px;
        top: 108px;

        img {
            width: 72px;
            height: 72px;
        }
    }

    .parkingLot-content {
        width: 750px;
        height: 536px;
        padding: 18px 24px;

        .parkingLot-content-hide {
            width: 112px;
            height: 6px;
            background: #666666;
            border-radius: 3px;
            flex-shrink: 0;
        }

        .parkingLot-content-statistics {
            width: 702px;
            height: 56px;
            background: #009af333;
            border-radius: 16px;
            font-size: 26px;
            color: #666666;
            padding: 17px 24px;
            margin: 17px 0;

            img {
                width: 24px;
                height: 24px;
                margin-right: 18px;
            }

            .parkingLot-content-statistics-num {
                color: @main-color;
                padding: 0 10px;
                text-decoration: underline;
            }

            .parkingLot-content-statistics-divider {
                margin: 0 20px;
                font-size: 30px;
            }
        }

        .parkingLot-content-list {
            overflow-y: scroll;
            padding-bottom: 100px;

            .parkingLot-content-item {
                width: 702px;
                height: 128px;
                margin-bottom: 16px;

                .parkingLot-content-item-type {
                    writing-mode: vertical-rl;
                    font-size: 28px;
                    color: #ffffff;
                    text-shadow: 0px 0px 8px rgba(0, 52, 110, 0.5);
                    margin-left: 10px;
                }

                .parkings-result-item {
                    width: 640px;
                    height: 126px;
                    // background-color: #fff;
                    padding: 15px 20px 15px 32px;
                    border-radius: 15px;
                    // border-bottom: 1px solid #DBDADA;

                    .result-item-left {
                        height: 100%;
                        width: 480px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        .result-item-name {
                            font-size: 32px;
                            color: #333333;
                            // margin-bottom: 10px;
                        }
                    }

                    .result-item-right {
                        margin-left: auto;
                        color: #666666;
                        // border-left: 1px solid #009AF34D;
                        // padding-left: 40px;

                        img {
                            width: 48px;
                            height: 48px;
                            margin-bottom: 4px;
                        }
                    }
                }
            }

            .parkingLot-content-item-road {
                width: 702px;
                height: 128px;
                background: url("~@/assets/images/parking/parking-road.png") no-repeat;
                background-size: 100% 100%;
            }

            .parkingLot-content-item-park {
                width: 702px;
                height: 128px;
                background: url("~@/assets/images/parking/parking-park.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .parkingLot-detail {
        width: 750px;
        height: 540px;
        padding: 18px 24px;

        .parkingLot-detail-hide {
            width: 112px;
            height: 6px;
            background: #666666;
            border-radius: 3px;
            flex-shrink: 0;
        }

        .parkingLot-detail-content {
            width: 100%;

            .parkingLot-detail-name {
                margin-top: 32px;

                img {
                    width: 50px;
                    height: 50px;
                }

                font-size: 36px;
                color: #333333;
                margin-left: 18px;
            }

            .parkingLot-detail-number-wrap {
                color: #666666;
                font-size: 28px;
                border-bottom: 1px solid #e8e8e8;
                padding: 30px 0;
            }

            .parkingLot-detail-rule {
                margin-top: 25px;
                margin-bottom: 48px;

                .parkingLot-detail-rule-left {
                    font-size: 28px;
                    color: #666666;

                    img {
                        width: 24px;
                        height: 24px;
                        margin-right: 18px;
                    }
                }

                .parkingLot-detail-rule-right {
                    margin-left: auto;

                    img {
                        width: 15px;
                        height: 25px;
                    }
                }
            }
        }
    }

    .van-action-sheet {
        z-index: 10000 !important;
    }

    .result-item-number {
        color: #666666;

        .result-item-number-total {
            font-size: 32px;
        }

        .result-item-number-surplus {
            font-size: 40px;
        }

        .result-item-number0 {
            color: #f72d2d;
        }

        .result-item-number20 {
            color: #f76a2d;
        }

        .result-item-number40 {
            color: #41cf8a;
        }
    }
}
</style>
<style lang="less">
.parking-amap {
    .amap-marker-content-green {
        width: 160px;
        height: 87px;
        color: #fff;
        background: url("~@/assets/images/home/parking-green.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        color: #41cf8a;

        .parkinglot-name-green {
            width: 135px;
            text-align: center;
            margin: 0 auto;
            padding-top: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .parkinglot-num-green {
            text-align: center;
            margin: 0 auto;
        }
    }

    .amap-marker-content-red {
        width: 160px;
        height: 87px;
        color: #fff;
        background: url("~@/assets/images/home/parking-red.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        color: #f72d2d;

        .parkinglot-name-red {
            width: 135px;
            text-align: center;
            margin: 0 auto;
            padding-top: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .parkinglot-num-red {
            text-align: center;
            margin: 0 auto;
        }
    }

    .amap-marker-content-orange {
        width: 160px;
        height: 87px;
        color: #fff;
        background: url("~@/assets/images/home/parking-orange.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        color: #f76a2d;

        .parkinglot-name-orange {
            width: 135px;
            text-align: center;
            margin: 0 auto;
            padding-top: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .parkinglot-num-orange {
            text-align: center;
            margin: 0 auto;
        }
    }

    .amap-marker-content-road {
        width: 130px;
        height: 149px;
        color: #fff;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        padding-top: 30px;
        align-items: center;
        background: url("~@/assets/images/home/parking-road.png") no-repeat;
        background-size: 100% 100%;
        font-size: 26px;
        color: #ffffff;

        .parkinglot-name-road {
            width: 135px;
            text-align: center;
            margin: 0 auto;
            padding-top: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .parkinglot-num-road {
            text-align: center;
            margin: 0 auto;
        }
    }

    .toll-rule-wrap {
        border-radius: 20px;
        background-color: #fff;
        padding-bottom: 30px;

        .toll-rule-wrap-header {
            padding: 32px;
            font-size: 34px;
            border-bottom: 1px solid #d5d5d5;
            color: #212121;

            img {
                width: 40px;
                height: 40px;
            }
        }

        .toll-rule-item {
            padding: 0 30px;
            margin: 30px 0;

            .toll-rule-item-title {
                font-size: 30px;
                color: #212121;
            }

            .toll-rule-item-content {
                font-size: 24px;
                color: #333333;
                margin-top: 10px;
            }
        }
    }
}
</style>
<style lang="less">
.toll-rule-dialog {
    .van-overlay {
        z-index: 10001 !important;
    }

    .van-dialog {
        z-index: 10001 !important;
        border-radius: 0;
        background: none;
    }
}

.scale_content {
    position: fixed;

    right: 32px;
    bottom: 108px;
    width: 72px;
    height: 144px;
    background: white;
    border-radius: 16px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    align-items: center;
}

.scale_item {
    width: 72px;
    height: 72px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-size: 48px;
    color: rgba(0, 0, 0, 0.5);
}

.divider {
    width: 90%;
    height: 2px;
    background: rgba(0, 0, 0, 0.1);
}

.position_icon {
    position: fixed;
    left: 32px;
    bottom: 108px;
    background: url("../../assets/images/position.png");
    background-size: 100% 100%;
    width: 80px;
    height: 80px;
    border-radius: 16px;
}

.scale_item:active,
.position_icon:active {
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
}

.location-point {
    height: 60px;
    width: 28px;
    background: url("../../assets/images/home/point.png");
    background-size: 100% 100%;
}

.comfirm-btn {
    color: #fff;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
</style>
